import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { BsTable } from "react-icons/bs";
import {
  isNumber,
  numberWithCommas,
  sortAMCS,
} from "../../utils/customFunction";
import { getAmc } from "../../stores/services/amc.service";
import {
  getSearchUnitholders,
  getUnitHoldersByAmcAndFolioNo,
} from "../../stores/services/unit-holder.service";
import { getUnitHolderStatement } from "../../stores/services/report.service";
import { PDFExport } from "@progress/kendo-react-pdf";
import ReportHeader from "./report-header";
import Select from "react-select";
import useCustomStyles from "../../hooks/useCustomStyles";
import { getFundByAmc } from "../../stores/services/funds.service";

const UnitHolderStatement = () => {
  const pdfExportComponent = useRef<PDFExport>(null);
  const [loading, setLoading] = useState(false);
  const email = sessionStorage.getItem("email") || "";
  const date = new Date();
  const [unitHolderStatement, setUnitHolderStatement] = useState<any[]>([]);
  const [unitHolderData, setUnitHolderData] = useState<any>([]);
  const [allAmc, setAllAmc] = useState<any[]>([]);
  const [folioNo, setFolioNo] = useState("");
  const [Amc, setAmc] = useState("");
  const [AmcCode, setAmcCode] = useState("");
  const [fromDate, setFromDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [allFunds, setAllFunds] = useState<any>();

  const [resFolioNo, setResFolioNo] = useState("");
  const [resAmc, setResAmc] = useState("");
  const [resFromDate, setResFromDate] = useState(
    moment(date).format("YYYY-MM-DD"),
  );
  const [resToDate, setResToDate] = useState(moment(date).format("YYYY-MM-DD"));

  const [folioNoErr, setFolioNoErr] = useState("");
  const [AmcErr, setAmcErr] = useState("");
  const [unitholderOptions, setUnitholderOptions] = useState<any[]>([]);
  const [unitholderLoading, setUnitholderLoading] = useState(false);
  const [unitholderSearchInput, setUnitholderSearchInput] = useState("");
  const { customStyles } = useCustomStyles();
  const [isParticipant, setIsParticipant] = useState<boolean>(false);
  // Participant-specific states
  const [participantRows, setParticipantRows] = useState<any[]>([]);
  const [participantOpeningAmount, setParticipantOpeningAmount] =
    useState<number>(0);
  const [participantClosingAmount, setParticipantClosingAmount] =
    useState<number>(0);

  useEffect(() => {
    if (unitHolderData?.unitholder_Type) {
      setIsParticipant(unitHolderData?.unitholder_Type === "Participant");
    }
  }, [unitHolderData]);

  const getAllFunds = async (valueIs) => {
    try {
      const response = await getFundByAmc(email, valueIs);
      setAllFunds(response.data.data);
    } catch (err: any) {
      toast.error(err.response?.data?.message || err.message);
    }
  };

  useEffect(() => {
    const getAllAMC = async () => {
      try {
        const amcResponse = await getAmc(email, "", "", "");
        const sortAMCByName = await sortAMCS(amcResponse.data.data);
        setAllAmc(sortAMCByName);
      } catch (err: any) {
        toast.error(err.response?.data?.message || err.message);
      }
    };

    getAllAMC();
  }, [email]);

  const txnTypes = JSON.parse(sessionStorage.getItem("txnType") || "[]");

  const CapTxnType = (type: string) => {
    const found = txnTypes.find((t: any) => t.api_name === type);
    return found ? found.dis_name : type;
  };

  const renderAmcDropdown = () => {
    return allAmc.map((item: any, index: number) => (
      <option key={index} value={item.amc_code.replace("AMC_", "")}>
        {item.name}
      </option>
    ));
  };

  const fetchInitialUnitholders = async (amcCode: string) => {
    try {
      setUnitholderLoading(true);
      const response = await getUnitHoldersByAmcAndFolioNo(
        email,
        amcCode,
        "",
        "1",
        "100",
      );
      if (response.data.status === 200) {
        const options = response.data.data.map((uh: any) => ({
          value: uh.folio_no,
          label: `${uh.folio_no} - ${uh.name}`,
          ...uh,
          unitholder_name: uh.name,
          folio_no: uh.folio_no,
          account_title: uh.account_title,
          account_no: uh.account_no,
          bank_name: uh.bank_name,
          branch_name: uh.branch_name,
          type: uh.type,
          systematic_investment: uh.systematic_investment || {},
        }));
        setUnitholderOptions(options);
      } else {
        setUnitholderOptions([]);
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to load unitholders");
      setUnitholderOptions([]);
    } finally {
      setUnitholderLoading(false);
    }
  };

  const searchUnitholders = async (searchValue: string, amcCode: string) => {
    if (!searchValue || searchValue.length < 2) {
      await fetchInitialUnitholders(amcCode);
      return;
    }
    try {
      setUnitholderLoading(true);
      const response = await getSearchUnitholders(email, amcCode, searchValue);
      if (response.data.status === 200) {
        const options = response.data.data.map((uh: any) => ({
          value: uh.folio_no,
          label: `${uh.folio_no} - ${uh.name}`,
          ...uh,
          unitholder_name: uh.name,
          folio_no: uh.folio_no,
          account_title: uh.account_title,
          account_no: uh.account_no,
          bank_name: uh.bank_name,
          branch_name: uh.branch_name,
          type: uh.type,
          systematic_investment: uh.systematic_investment || {},
        }));
        setUnitholderOptions(options);
      } else {
        setUnitholderOptions([]);
      }
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message || "Failed to search unitholders",
      );
    } finally {
      setUnitholderLoading(false);
    }
  };

  useEffect(() => {
    if (!AmcCode) return;
    const timeoutId = setTimeout(() => {
      if (unitholderSearchInput) {
        searchUnitholders(unitholderSearchInput, AmcCode);
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [unitholderSearchInput, AmcCode]);

  const handleUnitholderChange = (selected: any) => {
    if (!selected) setFolioNo("");
    else {
      setUnitHolderData(selected);
      setFolioNo(selected.folio_no);
    }
  };

  const handleUnitholderInputChange = (inputValue: string) => {
    setUnitholderSearchInput(inputValue);
  };

  //  Update logic with proper handling of the Participant Structure
  const searchData = async () => {
    try {
      let fund_wise_opening_balance: Record<string, any> = {};
      setLoading(true);
      setUnitHolderStatement([]);

      if (!Amc && !folioNo) {
        setAmcErr("required-border");
        setFolioNoErr("required-border");
        setLoading(false);
        return;
      } else if (!folioNo) {
        setFolioNoErr("required-border");
        setLoading(false);
        return;
      } else if (!Amc) {
        setAmcErr("required-border");
        setLoading(false);
        return;
      }

      const searchResponse = await getUnitHolderStatement(
        email,
        folioNo,
        fromDate,
        toDate,
      );

      // Calculate opening balance
      if (searchResponse.data.completed_txn) {
        for (const txn of searchResponse.data.completed_txn) {
          const fund = txn.fund_code;
          if (
            txn.txnr_type === "saleofunit" ||
            txn.txnr_type === "conversionin"
          ) {
            fund_wise_opening_balance[fund] = txn.total_holding;
          } else if (txn.txnr_type === "funddividendpayout") {
            fund_wise_opening_balance[fund] =
              (parseFloat(txn.current_holding || "0") || 0) +
              (parseFloat(txn.refund_of_capital || "0") || 0) +
              (parseFloat(txn.units || "0") || 0);
          } else if (txn.txnr_type === "transferofunits") {
            if (txn.broker === "receiver") {
              fund_wise_opening_balance[fund] =
                (parseFloat(txn.current_holding || "0") || 0) +
                (parseFloat(txn.units || "0") || 0);
            } else {
              fund_wise_opening_balance[fund] =
                parseFloat(txn.remain_holding || "0") || 0;
            }
          } else {
            fund_wise_opening_balance[fund] = txn.remain_holding;
          }
        }
      }

      if (
        searchResponse.data.status === 200 &&
        searchResponse.data.data.length > 0
      ) {
        setResAmc(Amc);
        setResFolioNo(AmcCode + "-" + folioNo);
        setResFromDate(fromDate);
        setResToDate(toDate);

        // **FIX: Group by parent fund code if systematic investment exists**
        const temp1 = searchResponse.data.data.map((item: any) => {
          const record = item.Record;
          // If it's a systematic investment, use the parent fund code
          if (record.systematic_investment?.investment_blocks?.[0]?.fund_code) {
            return record.systematic_investment.investment_blocks[0].fund_code;
          }
          return record.fund_code;
        });

        const unique_headings = Array.from(new Set(temp1));

        const allData = unique_headings.map((head: any) => {
          let fundName = head;

          let count = 0;
          let count_balance = 0;
          let open_balance = 0;
          let totalunits = 0;
          let totalgrossamount = 0;
          let totalnetamount = 0;
          let totalcgt = 0;
          let totalsaleload = 0;
          let totalredemptionload = 0;
          let totalrefundCapital = 0;

          const filteredData = searchResponse.data.data
            .filter((data: any) => {
              const record = data.Record;
              // **FIX: Match by parent fund code for systematic investments**
              if (
                record.systematic_investment?.investment_blocks?.[0]?.fund_code
              ) {
                return (
                  record.systematic_investment.investment_blocks[0]
                    .fund_code === head
                );
              }
              return record.fund_code === head;
            })
            .map((data: any, i: number) => {
              const record = { ...data.Record };
              record.units = isNumber(record.units);
              record.sale_load = isNumber(record.sale_load);

              count += 1;
              if (count === 1) {
                open_balance = fund_wise_opening_balance[head]
                  ? parseFloat(
                      String(fund_wise_opening_balance[head]).replace(/,/g, ""),
                    ) || 0
                  : 0;
                count_balance += open_balance;
              }

              totalgrossamount +=
                parseFloat(
                  String(record.gross_amount || 0).replace(/,/g, ""),
                ) || 0;
              totalnetamount +=
                parseFloat(String(record.net_amount || 0).replace(/,/g, "")) ||
                0;
              totalcgt +=
                parseFloat(String(record.tax_cgt || 0).replace(/,/g, "")) || 0;
              totalredemptionload +=
                parseFloat(
                  String(record.redemption_load || 0).replace(/,/g, ""),
                ) || 0;
              totalsaleload +=
                parseFloat(String(record.sale_load || 0).replace(/,/g, "")) ||
                0;
              totalrefundCapital +=
                parseFloat(
                  String(record.refund_of_capital || 0).replace(/,/g, ""),
                ) || 0;

              if (
                record.txnr_type === "saleofunit" ||
                record.txnr_type === "conversionin"
              ) {
                const units =
                  parseFloat(String(record.units || 0).replace(/,/g, "")) || 0;
                count_balance += units;
              } else if (record.txnr_type === "funddividendpayout") {
                const units =
                  parseFloat(String(record.units || 0).replace(/,/g, "")) || 0;
                const refund =
                  parseFloat(
                    String(record.refund_of_capital || 0).replace(/,/g, ""),
                  ) || 0;
                count_balance += units + refund;
              } else if (record.txnr_type === "transferofunits") {
                let totalTransferred = 0;
                try {
                  const transferees = JSON.parse(record.transfrees || "[]");
                  for (const t of transferees) {
                    if (t.folio_no === AmcCode + "-" + folioNo) {
                      totalTransferred +=
                        parseFloat(
                          String(t.transferees_unit_transfer || 0).replace(
                            /,/g,
                            "",
                          ),
                        ) || 0;
                    }
                  }
                } catch (e) {}
                if (record.broker === "receiver") {
                  count_balance += totalTransferred;
                  record.units = totalTransferred.toString();
                } else {
                  count_balance -= totalTransferred;
                  record.units = totalTransferred.toString();
                }
              } else {
                const units =
                  parseFloat(String(record.units || 0).replace(/,/g, "")) || 0;
                count_balance -= units;
              }

              totalunits +=
                parseFloat(String(record.units || 0).replace(/,/g, "")) || 0;
              record.count_balance = count_balance;
              return record;
            });

          return {
            heading: `${fundName}(${head})`,
            data1: filteredData.map((r: any) => ({ Record: r })),
            opening_balance: open_balance,
            closing_balance: count_balance,
            total_units: totalunits.toFixed(2),
            total_grossAmount: totalgrossamount.toFixed(2),
            total_netAmount: totalnetamount.toFixed(2),
            total_CGT: totalcgt.toFixed(2),
            total_redemptionLoad: totalredemptionload.toFixed(2),
            total_saleLoad: totalsaleload.toFixed(2),
            total_refundCapital: totalrefundCapital.toFixed(2),
          };
        });

        // Rest of your participant processing code remains the same
        let forParticipant = allData?.map((ele) => {
          let allTransactions: any = [];

          ele?.data1?.forEach((ele1) => {
            let temp1 = ele1?.Record;
            let subFunds =
              temp1?.systematic_investment?.investment_blocks?.[0]?.subFunds;

            if (subFunds && subFunds.length > 0) {
              if (temp1?.txnr_type === "changeofallocation") {
                // CoA: emit one OUT row per from_fund and one IN row per to_fund
                subFunds.forEach((sf: any) => {
                  // OUT leg — deduct from from_fund
                  allTransactions.push({
                    date: temp1.created_at,
                    txn_id: temp1?.txn_id,
                    txnr_type: temp1?.txnr_type,
                    fund_code: sf?.from_fund,
                    nav: sf?.from_fund_nav,
                    units: parseFloat(sf?.from_fund_unit) || 0,
                    amount: sf?.amount,
                    _leg: "out",
                    holding: sf?.from_fund_holding || 0,
                    total_holding: temp1?.current_holding,
                  });

                  // IN leg — add to to_fund
                  allTransactions.push({
                    date: temp1.created_at,
                    txn_id: temp1?.txn_id,
                    txnr_type: temp1?.txnr_type,
                    fund_code: sf?.to_fund,
                    nav: sf?.to_fund_nav,
                    units: parseFloat(sf?.to_fund_unit) || 0,
                    amount: sf?.amount,
                    _leg: "in",
                    holding: sf?.to_fund_holding || 0, // likely 0 for new fund
                    total_holding: temp1?.current_holding,
                  });
                });
              } else {
                // investment / withdrawal / other
                const totalOpeningBalance =
                  temp1?.systematic_investment?.investment_blocks?.[0]
                    ?.total_holding || 0;

                subFunds.forEach((child: any) => {
                  allTransactions.push({
                    date: temp1.created_at,
                    txn_id: temp1?.txn_id,
                    txnr_type: temp1?.txnr_type,
                    fund_code: child?.fund_code,
                    nav: child?.nav,
                    units: parseFloat(child?.units) || 0,
                    amount: child?.amount || child?.gross_amount,
                    _leg: temp1?.txnr_type === "withdrawal" ? "out" : "in",
                    holding: parseFloat(child?.holding) || 0,
                    total_holding: temp1?.current_holding,
                    total_opening_balance: totalOpeningBalance || 0,
                  });
                });
              }
            }
          });

          // Group by fund_code — this now naturally creates new entries for to_funds
          const groupedByFund = allTransactions.reduce(
            (acc: any, transaction: any) => {
              const fundCode = transaction.fund_code;
              if (!acc[fundCode]) {
                acc[fundCode] = [];
              }
              acc[fundCode].push(transaction);
              return acc;
            },
            {},
          );

          let newChild = Object.keys(groupedByFund).map((fundCode) => [
            {
              fund_code: fundCode,
              subFunds: groupedByFund[fundCode],
              heading: ele?.heading,
            },
          ]);

          return {
            heading: ele?.heading,
            opening_balance: ele?.opening_balance || 0,
            closing_balance: ele?.closing_balance || 0,
            total_units: ele?.total_units || 0,
            total_grossAmount: ele?.total_grossAmount || 0,
            total_netAmount: ele?.total_netAmount || 0,
            total_CGT: ele?.total_CGT || 0,
            total_redemptionLoad: ele?.total_redemptionLoad || 0,
            total_saleLoad: ele?.total_saleLoad || 0,
            total_refundCapital: ele?.total_refundCapital || 0,
            newChild,
          };
        });

        const tempArr = forParticipant[0]?.newChild?.flat(1);

        const UpdatedArr = tempArr?.map((ele: any) => {
          let updatedSubFunds: any = [];
          let totalUnits = 0;
          let totalAmount = 0;
          let OpeningBalance = 0;

          ele?.subFunds?.forEach((ele1: any, index: number) => {
            let closingBalance: number;

            // Determine the seed balance for row 0
            // For a brand-new fund (CoA to_fund), holding will be 0
            // For an existing fund (CoA from_fund or investment), holding is the actual balance
            const prevClosing =
              index === 0
                ? parseFloat(ele1.holding) || 0
                : updatedSubFunds[index - 1].closing_balance;

            if (index === 0) {
              OpeningBalance = parseFloat(ele1.holding) || 0;
            }

            const units = parseFloat(ele1.units) || 0;

            if (ele1._leg === "in") {
              closingBalance = prevClosing + units;
            } else {
              // "out" leg
              closingBalance = prevClosing - units;
            }

            totalUnits += units;
            totalAmount += parseFloat(ele1.amount) || 0;

            updatedSubFunds.push({
              ...ele1,
              closing_balance: closingBalance,
            });
          });

          const totalClosingBalance =
            updatedSubFunds[updatedSubFunds.length - 1]?.closing_balance || 0;

          return {
            ...ele,
            subFunds: updatedSubFunds,
            opening_balance: OpeningBalance,
            closing_balance: totalClosingBalance,
            total_units: totalUnits,
            total_amount: totalAmount,
          };
        });

        setUnitHolderStatement(allData);
        if (unitHolderData?.unitholder_Type === "Participant") {
          setParticipantRows(UpdatedArr);
        }
      } else {
        toast.error("Data not found.");
      }
    } catch (err: any) {
      toast.error(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  const fundName = (value: string) => {
    let nameIs = allFunds?.find((ele) => ele?.symbol_code === value)?.fund_name;
    return nameIs ? nameIs : "";
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Unit Holder Statement</h4>
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col md="2">
                        <div className="form-group">
                          <label>Select AMC</label>
                          <select
                            className={`form-control ${AmcErr}`}
                            onChange={(e) => {
                              const selectedText =
                                e.target.options[e.target.selectedIndex].text;
                              setAmc(selectedText);
                              setAmcCode(e.target.value);
                              fetchInitialUnitholders(e.target.value);
                              setAmcErr("");
                              getAllFunds(e.target.value);
                            }}
                          >
                            <option value="" hidden>
                              Select AMC
                            </option>
                            {renderAmcDropdown()}
                          </select>
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="form-group">
                          <label>
                            Search & Select Unitholder{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            options={unitholderOptions}
                            onChange={handleUnitholderChange}
                            onInputChange={handleUnitholderInputChange}
                            placeholder="Search by folio number or name..."
                            isDisabled={!AmcCode}
                            isLoading={unitholderLoading}
                            isClearable
                            value={
                              unitholderOptions.find(
                                (opt) => opt.folio_no === folioNo,
                              ) || null
                            }
                            noOptionsMessage={() =>
                              unitholderLoading
                                ? "Searching..."
                                : "No unitholders found."
                            }
                            filterOption={null}
                            styles={customStyles}
                          />
                          <small className="text-muted">
                            Type folio number or name to search
                          </small>
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="form-group">
                          <label>Date From</label>
                          <input
                            type="date"
                            defaultValue={fromDate}
                            className="form-control"
                            onChange={(e) =>
                              setFromDate(
                                moment(e.target.value).format("YYYY-MM-DD"),
                              )
                            }
                          />
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="form-group">
                          <label>Date To</label>
                          <input
                            type="date"
                            defaultValue={toDate}
                            className="form-control"
                            onChange={(e) =>
                              setToDate(
                                moment(e.target.value).format("YYYY-MM-DD"),
                              )
                            }
                          />
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="mt-4">
                          <button
                            className="btn btn-primary"
                            onClick={searchData}
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                />
                                <span> Loading...</span>
                              </>
                            ) : (
                              <span>Search</span>
                            )}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>

                {/* Results Card */}
                <div className="card mt-3">
                  <div className="card-body">
                    <div
                      id="printDiv"
                      className="p-4"
                      style={{ background: "white", color: "black" }}
                    >
                      <PDFExport
                        paperSize="A4"
                        margin="1.5cm"
                        scale={0.6}
                        landscape={true}
                        repeatHeaders={true}
                        fileName={`Unit-Holder-Statement-${moment().format(
                          "YYYYMMDD",
                        )}.pdf`}
                        ref={pdfExportComponent}
                      >
                        {unitHolderStatement.length > 0 ? (
                          <>
                            <ReportHeader title="Unit Holder Statement" />
                            <Row>
                              {unitHolderData?.name && (
                                <Col md="4" style={{ marginLeft: "70px" }}>
                                  <Row>
                                    <Col md="5">
                                      <span
                                        className="text-nowrap"
                                        style={{ fontWeight: "bold" }}
                                      >
                                        Name:
                                      </span>
                                    </Col>
                                    <Col md="6">
                                      <span className="text-nowrap">
                                        {unitHolderData?.name}
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              )}
                              <Col md="4" style={{ marginLeft: "70px" }}>
                                <Row>
                                  <Col md="5">
                                    <span
                                      className="text-nowrap"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      AMC:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span className="text-nowrap">
                                      {resAmc}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                              <Col md="4" style={{ marginLeft: "70px" }}>
                                <Row>
                                  <Col md="5">
                                    <span
                                      className="text-nowrap"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      Unit Holder:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span className="text-nowrap">
                                      {resFolioNo?.split("-")?.length === 3
                                        ? resFolioNo?.replace(AmcCode + "-", "")
                                        : resFolioNo}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                              <Col md="4" style={{ marginLeft: "70px" }}>
                                <Row>
                                  <Col md="5">
                                    <span
                                      className="text-nowrap"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      From Date:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span className="text-nowrap">
                                      {moment(resFromDate).format("DD-MM-YYYY")}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                              <Col md="4" style={{ marginLeft: "70px" }}>
                                <Row>
                                  <Col md="5">
                                    <span
                                      className="text-nowrap"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      Report Date:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span className="text-nowrap">
                                      {moment().format("DD-MM-YYYY")}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                              <Col md="4" style={{ marginLeft: "70px" }}>
                                <Row>
                                  <Col md="5">
                                    <span
                                      className="text-nowrap"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      To Date:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span className="text-nowrap">
                                      {moment(resToDate).format("DD-MM-YYYY")}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            {unitHolderData && (
                              <>
                                <hr />
                                <Row>
                                  {unitHolderData.account_title && (
                                    <Col md="4" style={{ marginLeft: "70px" }}>
                                      <Row>
                                        <Col md="5">
                                          <span
                                            className="text-nowrap"
                                            style={{ fontWeight: "bold" }}
                                          >
                                            Account Title:
                                          </span>
                                        </Col>
                                        <Col md="6">
                                          <span className="text-wrap">
                                            {unitHolderData?.account_title}
                                          </span>
                                        </Col>
                                      </Row>
                                    </Col>
                                  )}
                                  {unitHolderData?.account_no && (
                                    <Col md="4" style={{ marginLeft: "70px" }}>
                                      <Row>
                                        <Col md="5">
                                          <span
                                            className="text-nowrap"
                                            style={{ fontWeight: "bold" }}
                                          >
                                            Account No.:
                                          </span>
                                        </Col>
                                        <Col md="6">
                                          <span className="text-wrap">
                                            {unitHolderData?.account_no}
                                          </span>
                                        </Col>
                                      </Row>
                                    </Col>
                                  )}
                                  {unitHolderData?.bank_name && (
                                    <Col md="4" style={{ marginLeft: "70px" }}>
                                      <Row>
                                        <Col md="5">
                                          <span
                                            className="text-nowrap"
                                            style={{ fontWeight: "bold" }}
                                          >
                                            Bank:
                                          </span>
                                        </Col>
                                        <Col md="6">
                                          <span className="text-wrap">
                                            {unitHolderData?.bank_name}
                                          </span>
                                        </Col>
                                      </Row>
                                    </Col>
                                  )}
                                  {unitHolderData?.branch_name && (
                                    <Col md="4" style={{ marginLeft: "70px" }}>
                                      <Row>
                                        <Col md="5">
                                          <span
                                            className="text-nowrap"
                                            style={{ fontWeight: "bold" }}
                                          >
                                            Branch:
                                          </span>
                                        </Col>
                                        <Col md="6">
                                          <span className="text-nowrap">
                                            {unitHolderData?.branch_name}
                                          </span>
                                        </Col>
                                      </Row>
                                    </Col>
                                  )}
                                </Row>
                              </>
                            )}

                            {/* Conditional Rendering */}
                            {isParticipant ? (
                              <>
                                <table
                                  className="report"
                                  style={{
                                    width: "100%",
                                    color: "black",
                                    borderCollapse: "collapse",
                                  }}
                                >
                                  <thead>
                                    <tr
                                      style={{
                                        borderBottom: "2px solid black",
                                        fontSize: "13px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      <th
                                        style={{
                                          width: "10%",
                                          padding: "8px",
                                          textAlign: "left",
                                        }}
                                      >
                                        Date
                                      </th>
                                      <th
                                        style={{
                                          width: "15%",
                                          padding: "8px",
                                          textAlign: "left",
                                        }}
                                      >
                                        TXN ID
                                      </th>
                                      <th
                                        style={{
                                          width: "15%",
                                          padding: "8px",
                                          textAlign: "left",
                                        }}
                                      >
                                        Type
                                      </th>
                                      <th
                                        style={{
                                          width: "15%",
                                          padding: "8px",
                                          textAlign: "left",
                                        }}
                                      >
                                        Fund
                                      </th>
                                      <th
                                        style={{
                                          width: "10%",
                                          padding: "8px",
                                          textAlign: "right",
                                        }}
                                      >
                                        NAV
                                      </th>
                                      <th
                                        style={{
                                          width: "10%",
                                          padding: "8px",
                                          textAlign: "right",
                                        }}
                                      >
                                        Units
                                      </th>
                                      <th
                                        style={{
                                          width: "12%",
                                          padding: "8px",
                                          textAlign: "right",
                                        }}
                                      >
                                        Amount
                                      </th>
                                      <th
                                        style={{
                                          width: "13%",
                                          padding: "8px",
                                          textAlign: "right",
                                        }}
                                      >
                                        Closing Balance
                                      </th>
                                    </tr>
                                  </thead>
                                </table>

                                {/* Participant Groups */}
                                             
                                {participantRows?.map((unitHolder, index) => {
                                  return (
                                    <div
                                      key={index}
                                      style={{ marginTop: "20px" }}
                                    >
                                      {/* Participant Header */}
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          marginBottom: "10px",
                                          borderTop: "1px solid #ddd",
                                          paddingTop: "10px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            fontSize: "13px",
                                            fontWeight: "bold",
                                            color: "black",
                                          }}
                                        >
                                          {fundName(unitHolder?.fund_code)
                                            ? `${fundName(
                                                unitHolder?.fund_code,
                                              )} (${unitHolder?.fund_code})`
                                            : ""}
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            color: "black",
                                          }}
                                        >
                                          <b>Opening Balance:</b>{" "}
                                          {numberWithCommas(
                                            parseFloat(
                                              unitHolder?.opening_balance || 0,
                                            ).toFixed(2),
                                          )}
                                        </div>
                                      </div>

                                      {/* Transaction Table */}
                                      <table
                                        className="report"
                                        style={{
                                          width: "100%",
                                          color: "black",
                                          borderCollapse: "collapse",
                                          fontSize: "12px",
                                        }}
                                      >
                                        <tbody>
                                          {unitHolder?.subFunds?.map(
                                            (item, idx) => {
                                              return (
                                                <React.Fragment key={idx}>
                                                  <tr
                                                    key={idx}
                                                    style={{
                                                      borderBottom:
                                                        "1px solid #eee",
                                                    }}
                                                  >
                                                    <td
                                                      style={{
                                                        width: "10%",
                                                        padding: "6px",
                                                      }}
                                                    >
                                                      {new Date(
                                                        item?.date,
                                                      ).toLocaleDateString(
                                                        "en-GB",
                                                      )}
                                                    </td>
                                                    <td
                                                      style={{
                                                        width: "15%",
                                                        padding: "6px",
                                                      }}
                                                    >
                                                      {item?.txn_id}
                                                    </td>
                                                    <td
                                                      style={{
                                                        width: "15%",
                                                        padding: "6px",
                                                      }}
                                                    >
                                                      {item?.txnr_type ===
                                                        "changeofallocation" &&
                                                      item?.allocation_type &&
                                                      item?.amount > 0 &&
                                                      item?.units > 0
                                                        ? `${item?.txnr_type} (${item?.allocation_type})`
                                                        : item?.txnr_type}
                                                    </td>
                                                    <td
                                                      style={{
                                                        width: "15%",
                                                        padding: "6px",
                                                      }}
                                                    >
                                                      {item?.fund_code}
                                                    </td>
                                                    <td
                                                      style={{
                                                        width: "10%",
                                                        padding: "6px",
                                                        textAlign: "right",
                                                      }}
                                                    >
                                                      {numberWithCommas(
                                                        parseFloat(
                                                          item?.nav || 0,
                                                        ).toFixed(2),
                                                      )}
                                                    </td>
                                                    <td
                                                      style={{
                                                        width: "10%",
                                                        padding: "6px",
                                                        textAlign: "right",
                                                      }}
                                                    >
                                                      {numberWithCommas(
                                                        parseFloat(
                                                          item?.units || 0,
                                                        ).toFixed(2),
                                                      )}
                                                    </td>
                                                    <td
                                                      style={{
                                                        width: "12%",
                                                        padding: "6px",
                                                        textAlign: "right",
                                                      }}
                                                    >
                                                      {numberWithCommas(
                                                        parseFloat(
                                                          item?.amount || 0,
                                                        ).toFixed(2),
                                                      )}
                                                    </td>
                                                    <td
                                                      style={{
                                                        width: "13%",
                                                        padding: "6px",
                                                        textAlign: "right",
                                                      }}
                                                    >
                                                      {/* {calculateClosingBalance(item, idx)} */}
                                                      {numberWithCommas(
                                                        parseFloat(
                                                          item?.closing_balance ||
                                                            0,
                                                        ).toFixed(2),
                                                      )}
                                                    </td>
                                                  </tr>
                                                </React.Fragment>
                                              );
                                            },
                                          )}
                                        </tbody>
                                        <tfoot>
                                          <tr>
                                            <th
                                              style={{
                                                width: "10%",
                                                padding: "6px",
                                              }}
                                            >
                                              Total
                                            </th>
                                            <th
                                              style={{
                                                width: "15%",
                                                padding: "6px",
                                              }}
                                            ></th>
                                            <th
                                              style={{
                                                width: "15%",
                                                padding: "6px",
                                              }}
                                            ></th>
                                            <th
                                              style={{
                                                width: "15%",
                                                padding: "6px",
                                              }}
                                            ></th>
                                            <th
                                              style={{
                                                width: "10%",
                                                padding: "6px",
                                                textAlign: "right",
                                              }}
                                            ></th>
                                            <th
                                              style={{
                                                width: "10%",
                                                padding: "6px",
                                                textAlign: "right",
                                              }}
                                            >
                                              {numberWithCommas(
                                                parseFloat(
                                                  unitHolder?.total_units || 0,
                                                ).toFixed(2),
                                              )}
                                            </th>
                                            <th
                                              style={{
                                                width: "12%",
                                                padding: "6px",
                                                textAlign: "right",
                                              }}
                                            >
                                              {numberWithCommas(
                                                parseFloat(
                                                  unitHolder?.total_amount || 0,
                                                ).toFixed(2),
                                              )}
                                            </th>
                                            <th
                                              style={{
                                                width: "13%",
                                                padding: "6px",
                                                textAlign: "right",
                                              }}
                                            >
                                              {/* {calculateClosingBalance(item, idx)} */}
                                            </th>
                                          </tr>
                                        </tfoot>
                                      </table>

                                      {/* Closing Balance */}
                                      <div
                                        style={{
                                          textAlign: "right",
                                          marginTop: "8px",
                                          marginBottom: "10px",
                                          fontSize: "12px",
                                          color: "black",
                                        }}
                                      >
                                        <b>Closing Balance:</b>{" "}
                                        {numberWithCommas(
                                          parseFloat(
                                            unitHolder?.closing_balance || 0,
                                          ).toFixed(2),
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </>
                            ) : (
                              <>
                                <table
                                  className="report"
                                  style={{ color: "black" }}
                                >
                                  <thead style={{ alignSelf: "center" }}>
                                    <tr
                                      style={{
                                        borderTop: "2px solid black",
                                        borderBottom: "2px solid black",
                                      }}
                                    >
                                      <th style={{ width: "5%" }}>Date</th>
                                      <th style={{ width: "10%" }}>TXN ID</th>
                                      <th style={{ width: "10%" }}>
                                        Description
                                      </th>
                                      <th
                                        className="text-right"
                                        style={{ width: "8%" }}
                                      >
                                        Refund Capital
                                      </th>
                                      <th
                                        className="text-right"
                                        style={{ width: "8%" }}
                                      >
                                        Fund Units
                                      </th>
                                      <th
                                        className="text-right"
                                        style={{ width: "5%" }}
                                      >
                                        NAV
                                      </th>
                                      <th
                                        className="text-right"
                                        style={{ width: "9%" }}
                                      >
                                        Gross Amount
                                      </th>
                                      <th
                                        className="text-right"
                                        style={{ width: "9%" }}
                                      >
                                        Net Amount
                                      </th>
                                      <th
                                        className="text-right"
                                        style={{ width: "9%" }}
                                      >
                                        Sale Load
                                      </th>
                                      <th
                                        className="text-right"
                                        style={{ width: "9%" }}
                                      >
                                        Redemption Load
                                      </th>
                                      <th
                                        className="text-right"
                                        style={{ width: "5%" }}
                                      >
                                        CGT
                                      </th>
                                      <th
                                        className="text-right"
                                        style={{ width: "13%" }}
                                      >
                                        Balance
                                      </th>
                                    </tr>
                                  </thead>
                                </table>
                                
                                {unitHolderStatement.map(
                                  (unitHolder, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <div
                                          className="float-left"
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {unitHolder.heading}
                                        </div>
                                        <div
                                          className="float-right pr-1"
                                          style={{ fontSize: "12px" }}
                                        >
                                          <b>Opening Balance</b>:{" "}
                                          {numberWithCommas(
                                            parseFloat(
                                              unitHolder.opening_balance,
                                            ).toFixed(2),
                                          )}
                                          <br />
                                        </div>
                                        <table
                                          className="report"
                                          style={{ color: "black" }}
                                        >
                                          <tbody className="report-table-body">
                                            {unitHolder.data1.map(
                                              (item: any, idx: number) => (
                                                <tr
                                                  key={idx}
                                                  style={{
                                                    alignSelf: "center",
                                                  }}
                                                >
                                                  <td style={{ width: "5%" }}>
                                                    {moment(
                                                      item.Record
                                                        .execution_date,
                                                    ).format("DD-MM-YYYY")}
                                                  </td>
                                                  <td style={{ width: "10%" }}>
                                                    {item.Record.txn_id}
                                                  </td>
                                                  <td style={{ width: "10%" }}>
                                                    {CapTxnType(
                                                      item.Record.txnr_type,
                                                    ) !== "Transfer of Units"
                                                      ? CapTxnType(
                                                          item.Record.txnr_type,
                                                        )
                                                      : item.Record.broker ===
                                                          "receiver"
                                                        ? CapTxnType(
                                                            item.Record
                                                              .txnr_type,
                                                          ) + " (receiver)"
                                                        : CapTxnType(
                                                            item.Record
                                                              .txnr_type,
                                                          ) + " (sender)"}
                                                  </td>
                                                  <td
                                                    className="text-right"
                                                    style={{ width: "8%" }}
                                                  >
                                                    {numberWithCommas(
                                                      parseFloat(
                                                        item.Record
                                                          .refund_of_capital ||
                                                          0,
                                                      ).toFixed(2),
                                                    )}
                                                  </td>
                                                  <td
                                                    className="text-right"
                                                    style={{ width: "8%" }}
                                                  >
                                                    {numberWithCommas(
                                                      parseFloat(
                                                        item.Record.units || 0,
                                                      ).toFixed(2),
                                                    )}
                                                  </td>
                                                  <td
                                                    className="text-right pr-3"
                                                    style={{ width: "5%" }}
                                                  >
                                                    {parseFloat(
                                                      item.Record.nav || 0,
                                                    ).toFixed(2)}
                                                  </td>
                                                  <td
                                                    className="text-right"
                                                    style={{ width: "9%" }}
                                                  >
                                                    {numberWithCommas(
                                                      parseFloat(
                                                        item.Record
                                                          .gross_amount || 0,
                                                      ).toFixed(2),
                                                    )}
                                                  </td>
                                                  <td
                                                    className="text-right"
                                                    style={{ width: "9%" }}
                                                  >
                                                    {numberWithCommas(
                                                      parseFloat(
                                                        item.Record
                                                          .net_amount || 0,
                                                      ).toFixed(2),
                                                    )}
                                                  </td>
                                                  <td
                                                    className="text-right"
                                                    style={{ width: "8%" }}
                                                  >
                                                    {numberWithCommas(
                                                      parseFloat(
                                                        item.Record.sale_load ||
                                                          0,
                                                      ).toFixed(2),
                                                    )}
                                                  </td>
                                                  <td
                                                    className="text-right"
                                                    style={{ width: "8%" }}
                                                  >
                                                    {numberWithCommas(
                                                      parseFloat(
                                                        item.Record
                                                          .redemption_load || 0,
                                                      ).toFixed(2),
                                                    )}
                                                  </td>
                                                  <td
                                                    className="text-right"
                                                    style={{ width: "5%" }}
                                                  >
                                                    {numberWithCommas(
                                                      parseFloat(
                                                        item.Record.tax_cgt ||
                                                          0,
                                                      ).toFixed(2),
                                                    )}
                                                  </td>
                                                  <td
                                                    className="text-right"
                                                    style={{ width: "13%" }}
                                                  >
                                                    {numberWithCommas(
                                                      parseFloat(
                                                        item.Record
                                                          .count_balance || 0,
                                                      ).toFixed(2),
                                                    )}
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                          </tbody>
                                          <tfoot>
                                            <tr>
                                              <th style={{ width: "5%" }}>
                                                Total
                                              </th>
                                              <th style={{ width: "10%" }}></th>
                                              <th style={{ width: "10%" }}></th>
                                              <th
                                                className="text-right"
                                                style={{
                                                  fontSize: "11px",
                                                  width: "8%",
                                                }}
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    unitHolder.total_refundCapital,
                                                  ).toFixed(2),
                                                )}
                                              </th>
                                              <th
                                                className="text-right"
                                                style={{
                                                  fontSize: "11px",
                                                  width: "8%",
                                                }}
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    unitHolder.total_units,
                                                  ).toFixed(2),
                                                )}
                                              </th>
                                              <th style={{ width: "5%" }}></th>
                                              <th
                                                className="text-right"
                                                style={{
                                                  fontSize: "11px",
                                                  width: "9%",
                                                }}
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    unitHolder.total_grossAmount,
                                                  ).toFixed(2),
                                                )}
                                              </th>
                                              <th
                                                className="text-right"
                                                style={{
                                                  fontSize: "11px",
                                                  width: "9%",
                                                }}
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    unitHolder.total_netAmount,
                                                  ).toFixed(2),
                                                )}
                                              </th>
                                              <th
                                                className="text-right"
                                                style={{
                                                  fontSize: "11px",
                                                  width: "9%",
                                                }}
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    unitHolder.total_saleLoad,
                                                  ).toFixed(2),
                                                )}
                                              </th>
                                              <th
                                                className="text-right"
                                                style={{
                                                  fontSize: "11px",
                                                  width: "9%",
                                                }}
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    unitHolder.total_redemptionLoad,
                                                  ).toFixed(2),
                                                )}
                                              </th>
                                              <th
                                                className="text-right"
                                                style={{
                                                  fontSize: "11px",
                                                  width: "5%",
                                                }}
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    unitHolder.total_CGT,
                                                  ).toFixed(2),
                                                )}
                                              </th>
                                              <th style={{ width: "13%" }}></th>
                                            </tr>
                                          </tfoot>
                                        </table>
                                        <div
                                          className="float-right"
                                          style={{
                                            marginTop: "-20px",
                                            fontSize: "12px",
                                          }}
                                        >
                                          <b>Closing Balance</b>:{" "}
                                          {numberWithCommas(
                                            parseFloat(
                                              unitHolder.closing_balance,
                                            ).toFixed(2),
                                          )}
                                        </div>
                                        <br />
                                      </React.Fragment>
                                    );
                                  },
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <div className="table-empty">
                            <BsTable className="icon" />
                            <p className="text-center empty-text">
                              No record found
                            </p>
                          </div>
                        )}
                      </PDFExport>
                    </div>

                    <button
                      className="btn btn-primary mt-3"
                      onClick={() => {
                        if (pdfExportComponent.current) {
                          pdfExportComponent.current.save();
                        }
                      }}
                    >
                      Print
                    </button>
                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default UnitHolderStatement;
